/* eslint-disable unicorn/prefer-top-level-await */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/naming-convention */
// import { devtools, subscribeWithSelector } from 'zustand/middleware'
import axios from 'axios'
import { useCallback, useMemo } from 'react'
import { isEmpty } from 'remeda'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { gql, type TypedDocumentNode } from '@apollo/client'
import type {} from '@redux-devtools/extension'
import type {
  AdditionalCartInfoProductConnectionData,
  AdditionalCartInfoProductConnectionVariables,
  CartData,
  CartDataItem,
  CartError,
  TransformedCartData,
  TransformedCartDataItem,
} from '@velasca/types'
import { apolloClient } from '@velasca/utils/apollo-client'
import { $settings } from '@velasca/utils/globals'
import { handleError } from '@velasca/utils/handle-error'
import { trackEvent } from '@velasca/utils/track-event'
import { transformCart } from '@velasca/utils/transform-cart'

interface CartStore {
  isDrawerOpen: boolean
  cartData: TransformedCartData | null
  setCartData: (value: TransformedCartData | null) => void
  setError: (value: CartError) => void
  setLoading: (value: boolean) => void
  setIsDrawerOpen: (value: boolean) => void
  setRawCartData: (value: CartData) => void
  error: CartError
  loading: boolean
  rawCartData: CartData | null
}

const GET_ADDITIONAL_CART_INFO: TypedDocumentNode<
  AdditionalCartInfoProductConnectionData,
  AdditionalCartInfoProductConnectionVariables
> = gql`
  query GetAdditionalCartInfo($productIds: String!, $first: Int!) {
    products(query: $productIds, first: $first) {
      edges {
        node {
          id
          compareAtPriceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: 15) {
            edges {
              node {
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
          }
          customProductType: metafield(
            namespace: "custom"
            key: "product_type"
          ) {
            value
          }
          frontImageIndex: metafield(
            namespace: "custom"
            key: "front_image_index"
          ) {
            value
          }
          crossSellProductsEditorialImage: metafield(
            namespace: "custom"
            key: "cross_sell_products_editorial_image"
          ) {
            value
            reference {
              ... on MediaImage {
                image {
                  url
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`

const getCartRequest = () => axios.get<CartData>('/cart.js')

/**
 * TODO: controllare che questo CartData sia corretto nel caso di aggiunta al carrello.
 */
const addToCartRequest = (id: string, quantity: number) => {
  return axios.post<CartData>('/cart/add.js', {
    items: [
      {
        id: Number(id),
        quantity,
      },
    ],
  })
}

/**
 * TODO: controllare che questo CartData sia corretto nel caso di cambio nel carrello.
 */
const changeProductRequest = (id: string, quantity: number) => {
  return axios.post<CartData>('/cart/change.js', {
    id,
    quantity,
  })
}

const getGAProduct = (product: TransformedCartDataItem | CartDataItem) => {
  const {
    variant_id,
    sku,
    product_type,
    product_title,
    variant_title,
    vendor,
    quantity,
    price,
  } = product

  return {
    item_id: sku ?? variant_id,
    item_name: product_title,
    item_brand: vendor,
    item_category: product_type,
    item_variant: variant_title,
    price: (price / 100).toFixed(2),
    quantity,
  }
}

const formatCartItemForKlaviyoEvent = (
  item: CartDataItem | TransformedCartDataItem | undefined,
) => {
  const size = item?.options_with_values[0]?.value ?? ''
  const color = item?.options_with_values[1]?.value ?? ''
  const material = item?.options_with_values[2]?.value ?? ''

  return {
    name: item?.product_title,
    id: item?.product_id,
    price: item?.price ? item.price / 100 : 0,
    quantity: item?.quantity ?? 1,
    SKU: item?.sku ?? '',
    imageURL: item?.featured_image.url ?? '',
    URL: item?.url ?? '',
    size,
    color,
    material,
    variantId: item?.variant_id,
  }
}

// TODO: rimettere devtools
const useCartStore = create<CartStore>()(
  subscribeWithSelector((set) => {
    return {
      isDrawerOpen: false,
      cartData: null,
      error: null,
      loading: true,
      rawCartData: null,
      setIsDrawerOpen: (isDrawerOpen: boolean) => {
        set((s) => {
          if (!isDrawerOpen) {
            return { isDrawerOpen: false }
          }

          const { cartData } = s

          if (cartData) {
            const { total_price, currency, items } = cartData

            trackEvent({
              googleAnalytics: {
                eventName: 'view_cart',
                data: {
                  value: total_price / 100,
                  currency,
                  items: items.map((item) => getGAProduct(item)),
                },
              },
            })
          }

          return { isDrawerOpen }
        })
      },
      setCartData: (cart) => {
        set({
          cartData: cart,
        })
      },
      setError: (error: CartError) => {
        set({
          error,
        })
      },
      setLoading: (loading: boolean) => {
        set({
          loading,
        })
      },
      setRawCartData: (rawCartData: CartData) => {
        set({
          rawCartData,
        })
      },
    }
  }),
)

const loadAdditionalCartInfo = (
  variables: AdditionalCartInfoProductConnectionVariables,
) => {
  // TODO: Fix types
  return apolloClient.query({
    query: GET_ADDITIONAL_CART_INFO,
    variables,
  })
}

useCartStore.subscribe(
  ({ rawCartData }) => rawCartData,
  (rawCartData) => {
    if (!rawCartData) {
      return
    }

    // If products are the same, no need to call additionalCartInfo again
    // TODO: make this work by adding additionalCartInfoData to store
    // if(previousRawCartData?.items.map(({ product_id }) => product_id).sort().join(",") === rawCartData?.items.map(({ product_id }) => product_id).sort().join(",")) {
    //   useCartStore.setState({
    //     cartData:
    //       transformCart(
    //          rawCartData,
    //           additionalCartInfoData,
    //        ),
    //     })
    // }

    const productIds =
      rawCartData.items
        .map(({ product_id }) => `id:${product_id}`)
        .join(' OR ') ?? false
    const first = rawCartData.items.length

    if (!productIds || !first) {
      useCartStore.setState({
        cartData: null,
      })

      return
    }

    // TODO: When rawCartData
    loadAdditionalCartInfo({
      productIds,
      first,
    })
      .then(({ data: additionalCartInfoData }) => {
        useCartStore.setState({
          cartData: transformCart(rawCartData, additionalCartInfoData),
        })
      })
      .catch(handleError)
  },
)

// Calling cart ONCE per page
getCartRequest()
  .then((res) => {
    useCartStore.setState({
      rawCartData: res.data,
      cartData: transformCart(res.data, null),
    })
  })
  .catch((error) => {
    useCartStore.setState({ error })
  })
  .finally(() => {
    useCartStore.setState({ loading: false })
  })

export const useCart = () => {
  const {
    isDrawerOpen,
    setIsDrawerOpen,
    cartData,
    loading,
    error,
    setLoading,
    setError,
    setRawCartData,
  } = useCartStore()

  const fetchCart = useCallback(async () => {
    setLoading(true)
    setError(null)

    return getCartRequest()
      .then(({ data }) => {
        setRawCartData(data)
      })
      .catch((cartError) => {
        setError(cartError)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [setLoading, setError, setRawCartData])

  const addToCart = useCallback(
    (productID: string, quantity: number) => {
      setLoading(true)

      return addToCartRequest(productID, quantity)
        .then(async ({ data: partialCartData }) => {
          const { items } = partialCartData
          const productToAdd = items.find(
            (item) => String(item.id) === productID,
          )

          const cartTotal =
            (cartData?.total_price ?? 0) + (productToAdd?.price ?? 0)
          const totalCartItems = (cartData?.item_count ?? 0) + 1
          const cartItems = [...(cartData?.items ?? []), productToAdd].map(
            (item) => formatCartItemForKlaviyoEvent(item),
          )

          trackEvent({
            bingAds: {
              eventName: 'add_to_cart',
              data: {
                ecomm_pagetype: 'product',
                // I'm not quite sure this is correct. The "ecomm_prodid" should
                // be a list of all the products the user viewed on the page,
                // meaning also the products in the carousels. Here we are only
                // tracking the product of the current product page. But it's
                // better than nothing.
                ecomm_prodid: productID,
                currency: $settings.currency,
                items: [
                  {
                    id: productID,
                    quantity: 1,
                    price: productToAdd?.price ? productToAdd.price / 100 : 0,
                  },
                ],
                ...(productToAdd?.price
                  ? { ecomm_totalvalue: productToAdd.price / 100 }
                  : {}),
              },
            },
            klaviyo: {
              eventName: 'Added to cart',
              data: {
                currency: $settings.currency,
                cartTotal: cartTotal / 100,
                totalCartItems,
                addedItem: formatCartItemForKlaviyoEvent(productToAdd),
                cartItems,
              },
            },
            taboola: {
              eventName: 'add_to_cart',
              data: {
                revenue: productToAdd?.price ? productToAdd?.price / 100 : 0,
                currency: $settings.currency,
                orderid: productID,
                quantity: 1,
              },
            },
            teads: {
              eventName: 'AddToCart',
              data: {
                name: productToAdd?.product_title,
                price: productToAdd?.price ? productToAdd?.price / 100 : 0,
                currency: $settings.currency,
              },
            },
          })

          await fetchCart()
        })
        .finally(() => {
          setLoading(false)
        })
    },
    [cartData, fetchCart, setLoading],
  )

  const changeProduct = useCallback(
    (productID: string, quantity: number) => {
      setLoading(true)

      return changeProductRequest(productID, quantity)
        .then(async ({ data: partialCartData }) => {
          const { currency, items, total_price, item_count } = partialCartData
          const cartItems = items.map((item) =>
            formatCartItemForKlaviyoEvent(item),
          )

          trackEvent({
            klaviyo: {
              eventName: 'Added to cart',
              data: {
                currency,
                cartTotal: total_price / 100,
                totalCartItems: item_count,
                cartItems,
              },
            },
          })

          const currentProduct = items.find(
            (item) => item.variant_id.toString() === productID,
          )

          if (
            currentProduct &&
            (currentProduct.quantity - quantity === 0 || quantity === 0)
          ) {
            trackEvent({
              googleAnalytics: {
                eventName: 'remove_from_cart',
                data: {
                  value: currentProduct.line_price / 100,
                  currency,
                  items: [getGAProduct(currentProduct)],
                },
              },
            })
          }

          await fetchCart()
        })
        .finally(() => {
          setLoading(false)
        })
    },
    [fetchCart, setLoading],
  )

  const cartItemCount = useMemo(() => cartData?.item_count || 0, [cartData])

  const suggestedProductsHandle = useMemo(() => {
    if (!cartData) {
      return ''
    }

    const cartItemsWithoutGiftCard = cartData.items.filter(
      (item) => !item.gift_card,
    )

    if (isEmpty(cartItemsWithoutGiftCard)) {
      return ''
    }

    return cartItemsWithoutGiftCard[0].handle
  }, [cartData])

  return {
    isDrawerOpen,
    setIsDrawerOpen,
    setError,
    data: cartData,
    cartItemCount,
    loading,
    error,
    addToCart,
    changeProduct,
    fetchCart,
    suggestedProductsHandle,
  }
}
